namespace TabAurous.Administration {
    export interface ConfigurationRow {
        Id?: number;
        Name?: string;
        Description?: string;
        Type?: string;
        Value?: string;
        Code?: number;
    }

    export namespace ConfigurationRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Administration.Configuration';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = '*';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            Description = "Description",
            Type = "Type",
            Value = "Value",
            Code = "Code"
        }
    }
}
